import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { ResolutionStore } from '../../stores';
import { Resolution } from '../../types/resolution';
import { buildBackgroundContent } from './resolutionContent';
import { ResolutionSummary } from './resolutionSummary';

export type BackgroundResolutionInfoProps = {
  resolution: Resolution;
  resolutionStore: ResolutionStore;
  showComment?: boolean;
};

export const BackgroundResolutionInfo = observer(({ resolution, resolutionStore, showComment }: BackgroundResolutionInfoProps) => {
  // Internal users need the full record to resolve; the borrower view masks personal data.
  const maskSensitive = !resolutionStore.internal;
  const content = useMemo(() => buildBackgroundContent(resolution, maskSensitive), [resolution?.itemName, resolution?.itemDescription, maskSensitive]);

  return <ResolutionSummary resolution={resolution} resolutionStore={resolutionStore} content={content} showComment={showComment} />;
});
